import { useGet } from '../../../hooks/useApi';
import {
    notificationsAPI,
    NotificationsModel,
} from '../../../APIs/notificationsAPI';
import { NotificationList } from './table';
import { Button } from '../../atomic/buttons';
import React from 'react';
import { Loading } from '../../atomic/effects';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../contexts/AuthContext';

export const SystemInfo = () => {
    const navigate = useNavigate();
    const { isSuperAdmin } = useAuth();

    const [notifications, setNotifications] =
        React.useState<NotificationsModel>([]);
    const { data, mutate, isLoading } = useGet(notificationsAPI.admin.get);

    React.useEffect(() => {
        if (data && data.data.length) {
            setNotifications(data.data);
        }
    }, [data]);

    if (isLoading) {
        return <Loading />;
    }

    const createLink = isSuperAdmin()
        ? '/app/superadmin/notification/create'
        : '/app/admin/notification/create';
    return (
        <div className="app-main admin-info">
            <div className="header">
                <h2 className="header-name">お知らせ一覧</h2>
                <Button
                    onClick={() => {
                        navigate(createLink);
                    }}
                >
                    新規作成
                </Button>
                <NotificationList
                    notifications={notifications}
                    mutate={mutate}
                />
            </div>
        </div>
    );
};
